import React from 'react';

function Home() {
  return (
    <section
      id="home"
      className="home h-screen flex items-center justify-center text-center bg-gradient-to-r from-gray-900 via-gray-700 to-gray-600 text-white px-4"
    >
      <div className="relative transform -translate-y-14"> {/* Moves the content upward */}
        {/* Profile Picture */}
        <div className="w-full max-w-[260px] sm:max-w-[300px] md:max-w-[340px] lg:max-w-[340px] mx-auto aspect-square relative mb-6">
          <div className="absolute inset-0 bg-gradient-to-br from-purple-100 to-blue-100 rounded-full animate-pulse" />
          <div className="absolute inset-4 bg-gradient-to-br from-purple-600/10 to-blue-600/10 rounded-full" />
          <div className="absolute inset-0 flex items-center justify-center">
            <img 
              src="https://www.shutterstock.com/shutterstock/videos/3556188977/thumb/11.jpg?ip=x480" 
              alt=""
             className="profile-image rounded-full w-full h-full object-cover shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-110"
            />
          </div>
        </div>

        {/* Heading */}
        <h1 className="custom-text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
          Hi, I'm <span className="text-green-400">Tushar Singha</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base sm:text-lg md:text-xl mt-4 mb-8 max-w-md sm:max-w-lg mx-auto">
          A Passionate Web Developer and BCA Student
        </p>

        {/* Call-to-Action Button */}
        <a
          href="#contact"
          className="mt-6 px-6 py-3 text-sm sm:text-base md:text-lg bg-green-500 text-white rounded-md hover:bg-green-600 active:scale-95 active:bg-green-800 transition-all"
        >
          Get In Touch
        </a>
      </div>
    </section>
  );
}

export default Home;